import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import { useContext } from 'react';
import { useQuery, useQueryClient, useMutation } from 'react-query';
import * as api from '../../services/api';
import useToaster from '../useToaster';
import { QUERY_CACHE_TIME } from '../../constants';
import useAccount from './useAccount';

const useSupplier = ({ supplierId } = {}) => {
  const { t } = useContext(ConfigContext);
  const { accountId } = useAccount();
  const queryClient = useQueryClient();

  const storeKey = ['supplier', accountId, supplierId];
  const suppliersStoreKey = ['suppliers', accountId];
  const { isLoading, data } = useQuery(storeKey, () => api.fetchSupplier({ accountId, supplierId }), {
    staleTime: QUERY_CACHE_TIME,
    cacheTime: QUERY_CACHE_TIME,
    enabled: !!supplierId
  });

  const { addSuccess } = useToaster();

  const { mutateAsync: updateSupplier } = useMutation(
    (values) => {
      return supplierId
        ? api.updateSupplier({ accountId, supplierId, ...values })
        : api.addSupplier({ accountId, ...values });
    },
    {
      throwOnError: true,
      onSuccess: () => {
        queryClient.invalidateQueries(storeKey);
        queryClient.invalidateQueries(suppliersStoreKey);
        addSuccess(supplierId ? t('successUpdateSupplier') : t('successAddSupplier'));
      }
    }
  );

  return {
    loading: isLoading,
    data: data?.data,
    updateSupplier
  };
};

export default useSupplier;
